import React from "react";
import { FormattedNumber } from "react-intl";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";

import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import type { TCatalog, TVehicle } from "types";

import { Pipeline } from "components/Pipeline";

interface IFilterStatus {
  catalog: TCatalog;
  vehicles: TVehicle[];
  filter: any;
  dispatchFilter: any;
  sx?: any;
}

export const FilterStatus: React.FC<IFilterStatus> = ({
  catalog,
  vehicles,
  filter,
  dispatchFilter = () => null,
  sx = {},
}): JSX.Element | null => {
  const [vehicleCount, setVehicleCount] = React.useState<number>(0);

  React.useEffect(() => {
    if (!vehicles) return;
    const filteredVehicleCount = vehicles.length;
    setVehicleCount(filteredVehicleCount);
  }, [vehicles]);

  if (!catalog) return null;

  const catalogCount = catalog.result?.vehicle?.length || 0;

  const clearFilterHandler = () => {
    dispatchFilter({ type: "RESET_FILTER" });
  };

  return (
    <Box data-testid="filter-status" sx={{ ...sx }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="body1">
          <FormattedNumber value={vehicleCount} />
          &nbsp;Angebote
        </Typography>

        <Button
          disableRipple
          disabled={vehicleCount === catalogCount}
          endIcon={<FilterAltOffIcon />}
          onClick={clearFilterHandler}
          color="primary"
        >
          <Typography variant="body2">Filter löschen</Typography>
        </Button>
      </Box>
      <LinearProgress
        sx={{
          height: 13,
        }}
        color="primary"
        variant="determinate"
        value={(vehicleCount / catalogCount) * 100}
      />
    </Box>
  );
};

interface IContainer {
  Pipe?: any;
  sx?: any;
}

const Container: React.FC<IContainer> = ({ Pipe = Pipeline, sx = {} }) => {
  return <Pipe Component={FilterStatus} sx={sx} />;
};

export default Container;
